import Loc from "localization";

var allConfigsList = [{ key: "has-duration", name: Loc.has_duration }];

export default allConfigsList;